import { UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_FAILURE } from '../actions/update_profile'

export function updateProfile(
  state = {
    isFetching: false,
    user: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        user: null,
        isFetching: true,
        errorMessage: null,
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        user: action.response,
      }
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        errors: null,
        user: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
